/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Neat_Wren_HuntInputs */

const fr_simple_neat_wren_hunt = /** @type {(inputs: Simple_Neat_Wren_HuntInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reçu`)
};

/**

* @param {Simple_Neat_Wren_HuntInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const simple_neat_wren_hunt = /** @type {((inputs?: Simple_Neat_Wren_HuntInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Neat_Wren_HuntInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_simple_neat_wren_hunt(inputs)
});